<template>
  <div class="step1" v-loading="loading" style="">
    <div style="width: 1000px; margin: auto">
      <img
        src="../assets/img/grrzxx.png"
        alt=""
        srcset=""
        width="150px"
        style="margin: 50px auto 40px; display: block"
      >
      <div style="margin: auto; text-align: center">
        <span style="color: #2860ec">*</span>
        <span style="font-size: 14px; margin-right: 10px">证件类型:</span>
        <el-radio-group
          v-model="form.zjlx"
          :disabled="step == 5"
          @change="typeChange"
        >
          <el-radio label="1">身份证</el-radio>
          <el-radio label="4">其他证件</el-radio>
        </el-radio-group>
      </div>
      <div v-if="form.zjlx == 1">
        <div class="card_img">
          <div class="card_img_item">
            <div style="position: relative">
              <el-upload
                :disabled="step == 5"
                class="upload-demo"
                :action="returnSaveFile"
                :data="cardImg[0].OCR"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :before-upload="beforeUpload"
                :on-success="onSuccess"
                :show-file-list="false"
                :on-error="onError"
                :on-progress="onProgress"
                :on-exceed="handleExceed"
                :headers="token"
              >
                <el-image
                  v-loading="cardImg[0].loading"
                  v-preventReClick
                  style="width: 227px; height: 140px"
                  :src="cardImg[0].img"
                  :fit="cardImg[0].name"
                  @click="cardType = cardImg[0].name"
                />
              </el-upload>
              <div
                v-show="cardImg[0].closeBox"
                v-preventReClick
                class="deleteUpload"
                @click="removeCurImg(cardImg[0].name)"
              >
                <i class="el-icon-circle-close" />
              </div>
            </div>
            <span>{{ cardImg[0].name }}</span>
          </div>
          <div class="card_img_item">
            <div style="position: relative">
              <el-upload
                :disabled="step == 5"
                class="upload-demo"
                :action="returnSaveFile"
                :data="cardImg[1].OCR"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :before-upload="beforeUpload"
                :on-success="onSuccess1"
                :show-file-list="false"
                :on-error="onError"
                :on-progress="onProgress1"
                :on-exceed="handleExceed"
                :headers="token"
              >
                <el-image
                  v-loading="cardImg[1].loading"
                  style="width: 227px; height: 140px"
                  :src="cardImg[1].img"
                  :fit="cardImg[1].name"
                />
              </el-upload>
              <div
                v-show="cardImg[1].closeBox"
                v-preventReClick
                class="deleteUpload"
                @click="removeCurImg(cardImg[1].name)"
              >
                <i class="el-icon-circle-close" />
              </div>
            </div>
            <span>{{ cardImg[1].name }}</span>
          </div>
        </div>
        <div style="">
          <p>身份证件信息</p>
          <div class="CardXX">
            <el-form
              ref="form"
              :rules="rules"
              :model="form"
              label-width="89px"
              label-position="left"
            >
              <el-form-item label="姓名:" prop="xm">
                <el-input
                  v-model="form.xm"
                  :disabled="step == 5"
                  maxlength="200"
                  placeholder="请输入姓名"
                />
              </el-form-item>
              <el-form-item label="性别:" prop="xb">
                <el-select
                  v-model="form.xb"
                  :disabled="step == 5"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, i) in sexList"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="证件号码:" prop="zjhm">
                <el-input
                  v-model="form.zjhm"
                  :disabled="step == 5"
                  placeholder="请输入证件号码"
                  maxlength="50"
                />
              </el-form-item>
              <el-form-item label="民族:">
                <el-select
                  v-model="form.mz"
                  :disabled="step == 5"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, i) in mzList"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="出生日期:" prop="sr">
                <el-date-picker
                  v-model="form.sr"
                  :disabled="step == 5"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择出生日期"
                />
              </el-form-item>
              <el-form-item label="籍贯:">
                <el-cascader
                  v-model="jgnum"
                  :disabled="step == 5"
                  style="width: 340px"
                  clearable
                  placeholder=""
                  :props="props"
                  filterable
                  @change="jgChange"
                />
              </el-form-item>
              <el-form-item label="有效期限:" prop="yxqxKs">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.yxqxKs"
                    :disabled="step == 5"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择开始时间"
                    style="width: 100%"
                    :picker-options="this.startTime(form.yxqxJs)"
                  />
                </el-col>
                <el-col class="line" :span="2">至</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.yxqxJs"
                    type="date"
                    :disabled="step == 5"
                    value-format="yyyy-MM-dd"
                    placeholder="选择结束时间"
                    style="width: 100%"
                    :picker-options="this.endTime(form.yxqxKs)"
                  />
                </el-col>
              </el-form-item>
              <el-form-item label="发证机关:" prop="fzjg">
                <el-input
                  v-model="form.fzjg"
                  :disabled="step == 5"
                  maxlength="155"
                  placeholder="请输入机关名称"
                />
              </el-form-item>
            </el-form>
          </div>
          <p>其他信息</p>
          <div class="QtXX">
            <el-form
              ref="form2"
              :rules="rules"
              :model="form"
              label-width="89px"
              label-position="left"
            >
              <el-form-item label="办公电话:" prop="bgdh">
                <el-input
                  v-model="form.bgdh"
                  maxlength="50"
                  :disabled="step == 5"
                />
              </el-form-item>
              <el-form-item label="手机号码:">
                <el-input
                  v-model="form.sjhm"
                  maxlength="50"
                  disabled
                  readonly
                />
              </el-form-item>
              <el-form-item label="实际住址:" prop="sjzz">
                <el-input
                  v-model="form.sjzz"
                  maxlength="600"
                  :disabled="step == 5"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-- 其他证件表单 -->
      <div v-if="form.zjlx == 4">
        <div class="qita_img">
          <div class="qita_img_item">
            <div style="position: relative">
              <el-upload
                :disabled="step == 5"
                class="upload-demo"
                :action="returnSaveFile"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :before-upload="beforeUpload"
                :on-success="onSuccess"
                :show-file-list="false"
                :on-progress="onProgress"
                :on-exceed="handleExceed"
                :headers="token"
              >
                <el-image
                  v-loading="cardImg[2].loading"
                  v-preventReClick
                  style="width: 227px; height: 140px"
                  :src="cardImg[2].img"
                  @click="cardType = cardImg[2].name"
                />
              </el-upload>
              <div
                v-show="cardImg[2].closeBox"
                v-preventReClick
                class="deleteUpload"
                @click="removeCurImg(cardImg[2].name)"
              >
                <i class="el-icon-circle-close" />
              </div>
            </div>
            <span>{{ cardImg[2].name }}</span>
          </div>
        </div>
        <div style="">
          <p>身份证件信息</p>
          <div class="CardXX">
            <el-form
              ref="form"
              :rules="rules"
              :model="form"
              label-width="89px"
              label-position="left"
            >
              <el-form-item label="姓名:" prop="xm">
                <el-input
                  v-model="form.xm"
                  :disabled="step == 5"
                  placeholder="请输入姓名"
                />
              </el-form-item>
              <el-form-item label="性别:" prop="xb">
                <el-select
                  v-model="form.xb"
                  :disabled="step == 5"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, i) in sexList"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="证件号码:" prop="zjhm">
                <el-input
                  v-model="form.zjhm"
                  :disabled="step == 5"
                  placeholder="请输入证件号码"
                  maxlength="50"
                />
              </el-form-item>
              <el-form-item label="证件名称:" prop="qtzj">
                <el-select
                  v-model="form.qtzj"
                  :disabled="step == 5"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, i) in zjmcList"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="出生日期:" prop="sr">
                <el-date-picker
                  v-model="form.sr"
                  :disabled="step == 5"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择出生日期"
                />
              </el-form-item>
              <el-form-item label="民族:">
                <el-select
                  v-model="form.mz"
                  :disabled="step == 5"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, i) in mzList"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>

              <!-- <el-form-item label="籍贯:" prop="jgnum">
                <el-cascader
                  :disabled="step == 5"
                  style="width: 340px"
                  v-model="jgnum"
                  clearable
                  placeholder=""
                  :options="options"
                  filterable
                  @change="jgChange"
                ></el-cascader>
              </el-form-item> -->
              <el-form-item label="有效期限:" prop="yxqxKs">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.yxqxKs"
                    :disabled="step == 5"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择开始时间"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">至</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.yxqxJs"
                    type="date"
                    :disabled="step == 5"
                    value-format="yyyy-MM-dd"
                    placeholder="选择结束时间"
                    style="width: 100%"
                    :picker-options="this.endTime(form.yxqxKs)"
                  />
                </el-col>
              </el-form-item>
              <el-form-item label="发证机关:" prop="fzjg">
                <el-input
                  v-model="form.fzjg"
                  :disabled="step == 5"
                  placeholder="请输入机关名称"
                  maxlength="100"
                />
              </el-form-item>
            </el-form>
          </div>
          <p>其他信息</p>
          <div class="QtXX">
            <el-form
              ref="form2"
              :rules="rules"
              :model="form"
              label-width="89px"
              label-position="left"
            >
              <el-form-item label="办公电话:" prop="bgdh">
                <el-input
                  v-model="form.bgdh"
                  :disabled="step == 5"
                  maxlength="30"
                />
              </el-form-item>
              <el-form-item label="手机号码:">
                <el-input v-model="form.sjhm" disabled readonly />
              </el-form-item>
              <el-form-item label="实际住址:" prop="sjzz">
                <el-input
                  v-model="form.sjzz"
                  :disabled="step == 5"
                  maxlength="200"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div v-if="step != 5" class="_buttonList">
        <el-button v-preventReClick @click="upstep">上一步</el-button>
        <el-button
          v-preventReClick
          style="background-color: #4170ff; color: white"
          @click="submitForm('form', 'form2')"
        >下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// 获取接口地址
import {
  url1,
  getkv,
  getgrrzxx,
  zhuce,
  returnSaveFile,
  returnShowPic,
  getToken
} from '@/assets/js/common.js'
import { startTime, endTime, lengthValidate } from '@/assets/js/validate.js'
import { getXzqTree, getXzqTreeS } from '@/assets/js/step2.js'
export default {
  name: 'Step1',
  components: {},
  props: {
    step: Number
  },
  data() {
    const jgjiaoyan = (rule, value, callback) => {
      if (this.jgnum.length == 0) {
        return callback(new Error('请选择籍贯'))
      } else {
        callback()
      }
    }
    var validateCard = (rule, value, callback) => {
      if (this.form.zjlx == '1') {
        if (!this.IdentityCodeValid(value)) {
          callback(new Error('请输入正确的身份证号码'))
        } else {
          callback()
        }
      } else {
        lengthValidate(rule, value, callback, 'bt', 100)
      }
    }
    const phoneValidator = (rule, value, callback) => {
      const reg1 = /^(0\d{2,3}-\d{7,8})$/ // 座机
      const reg2 = /^1[3456789]\d{9}$/
      if (value) {
        if (!reg1.test(value) && !reg2.test(value)) {
          callback(new Error('请输入正确的电话或手机号格式'))
        }
      }
      callback()
    }
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '长期有效',
            onClick(picker) {
              const date = new Date('2099-12-31')
              picker.$emit('pick', date)
            }
          }
        ]
      },
      props: {
        lazy: true, // 开启懒加载
        lazyLoad(node, resolve) {
          const { level } = node
          setTimeout(() => {
            if (level == 0) {
              getXzqTree().then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            } else {
              getXzqTreeS(node.value).then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            }
          })
        }
      },
      loading: false,
      token: {
        Authorization: getToken()
      },
      returnSaveFile: '',
      returnShowPic: '',
      URL1: '',
      cardType: '',
      fileList: [],
      icon: false,
      value1: '',
      sexList: [
        {
          label: '男',
          value: '0'
        },
        {
          label: '女',
          value: '1'
        },
        {
          label: '未知',
          value: '2'
        }
      ],
      mzList: [],
      zjlxList: [],
      zjmcList: [],
      card: 1,
      qitaImg: {
        name: '其他证件',
        img: require('../assets/img/zjrlx.png'),
        closeBox: false,
        loading: true
      },
      cardImg: [
        {
          name: '证件人像面',
          img: require('../assets/img/zjrlx.png'),
          closeBox: false,
          loading: true,
          OCR: {
            sbzjlx: 'sfzZm'
          }
        },
        {
          name: '证件国徽面',
          img: require('../assets/img/zjghx.png'),
          closeBox: false,
          loading: true,
          OCR: {
            sbzjlx: 'sfzFm'
          }
        },
        {
          name: '其他证件',
          img: require('../assets/img/zjrlx.png'),
          closeBox: false,
          loading: true
        }
      ],
      jgnum: [],
      form: {
        id: '',
        dwid: '',
        xm: '',
        zw: '',
        jg: '',
        sjzz: '',
        bgdh: '',
        sjhm: '',
        zjlx: '',
        qtzj: '',
        zjhm: '',
        xb: '',
        mz: '',
        sr: '',
        yxqxKs: '',
        yxqxJs: '',
        fzjg: '',
        zjzpZm: '',
        zjzpFm: ''
      },
      options: [],
      rules: {
        bgdh: [{ validator: phoneValidator, trigger: ['blur', 'change'] }],
        xm: [
          { required: true, message: '请输入姓名', trigger: 'change' },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'change'
          }
        ],
        xb: [{ required: true, message: '请选择性别', trigger: 'change' }],
        sr: [{ required: true, message: '请选择出生日期', trigger: 'change' }],
        zjhm: [{ required: true, validator: validateCard, trigger: 'change' }],
        jgnum: [
          {
            validator: jgjiaoyan,
            trigger: 'change'
          }
        ],
        mz: [{ required: true, message: '请选择民族', trigger: 'change' }],
        yxqxKs: [
          { required: true, message: '请输入有效期限', trigger: 'change' }
        ],
        fzjg: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255)
            },
            trigger: 'change'
          }
        ],
        sjhm: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          {
            // pattern:
            //   /^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/,
            message: '手机号格式不对',
            // trigger: "change",
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              const mobile = /^1[3456789]\d{9}$/
              if (!value) {
                return callback(new Error('手机号不能为空！'))
              }
              if (!mobile.test(value)) {
                return callback(new Error('手机号格式错误！'))
              }
              callback()
            }
          }
        ],
        qtzj: [
          { required: true, message: '请选择证件名称', trigger: 'change' }
        ],
        qtzjhm: [
          { required: true, message: '请输入证件号码', trigger: 'change' }
        ],
        sjzz: [
          {
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'xt', 600)
            },
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  computed: {},
  created() {
    this.URL1 = url1()
    this.returnSaveFile = returnSaveFile()
    this.returnShowPic = returnShowPic()
    // 获取个人信息并展示
    this.get()
    getkv('yzd_mz').then((e) => {
      this.mzList = e.data.data
    })
    getkv('yzd_zjlx').then((e) => {
      this.zjlxList = e.data.data
    })
    getkv('yzd_ry_zjmc').then((e) => {
      this.zjmcList = e.data.data
    })
    // getjg().then((e) => {
    //   this.options = e.data.data;
    // });
  },
  methods: {
    lengthValidate,
    startTime,
    endTime,
    IdentityCodeValid(code) {
      // 验证身份证合法性
      var city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 '
      }
      var pass = true

      var patt1 = new RegExp(
        '(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$)'
      )
      if (!code || !patt1.test(code)) {
        pass = false
      } else if (!city[code.substr(0, 2)]) {
        pass = false
      } else {
        // 18位身份证需要验证最后一位校验位
        if (code.length == 18) {
          code = code.split('')
          // ∑(ai×Wi)(mod 11)
          // 加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          // 校验位
          var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
          var sum = 0
          var ai = 0
          var wi = 0
          for (var i = 0; i < 17; i++) {
            ai = code[i]
            wi = factor[i]
            sum += ai * wi
          }
          if (parity[sum % 11] != code[17]) {
            pass = false
          }
        }
      }
      return pass
    },

    get() {
      getgrrzxx().then((e) => {
        const data = e.data.data.oneData
        if (data.zjlx != '' && data.zjlx != null) {
          this.form.zjlx = data.zjlx
          this.form.zjlx == '4'
            ? (this.cardType = '其他证件')
            : (this.cardType = '证件人像面')
        } else {
          data.zjlx = '1'
          this.form.zjlx = data.zjlx
        }
        this.cardImg[0].loading = false
        this.cardImg[1].loading = false
        this.cardImg[2].loading = false

        // 将type存入vuex
        this.$store.commit('EditType', e.data.data.type)
        // 如果证件类型为空，默认是身份证 1

        if (data.zjzpZm) {
          if (data.zjlx == 1) {
            this.cardImg[0].img = this.returnShowPic + data.zjzpZm
          } else {
            this.cardImg[2].img = this.returnShowPic + data.zjzpZm
          }
        }
        if (data.zjzpFm) {
          if (data.zjlx == 1) {
            this.cardImg[1].img = this.returnShowPic + data.zjzpFm
          }
        }
        // 回显的数据
        this.form = data
        if (e.data.data.oneData.jg != '' && e.data.data.oneData.jg != null) {
          this.jgnum = e.data.data.oneData.jg.split(',').map(Number)
        }
      })
    },
    removeCurImg(type) {
      if (type == '证件人像面') {
        this.cardImg[0].img = require('../assets/img/zjrlx.png')
        this.cardImg[0].closeBox = false
        this.form.zjzpZm = ''
      }
      if (type == '证件国徽面') {
        this.cardImg[1].img = require('../assets/img/zjrlx.png')
        this.cardImg[1].closeBox = false
        this.form.zjzpFm = ''
      }
      if (type == '其他证件') {
        this.cardImg[2].img = require('../assets/img/zjrlx.png')
        this.cardImg[2].closeBox = false
        this.form.zjzpZm = ''
      }
    },

    typeChange(value) {
      if (value == '4') {
        this.form.zjzpZm = this.cardImg[2].img.split('picUrl=')[1]
      } else if ((value = '1')) {
        this.form.zjzpZm = this.cardImg[0].img.split('picUrl=')[1]
        this.form.zjzpFm = this.cardImg[1].img.split('picUrl=')[1]
      }
      /* this.cardImg.forEach((element) => {
        element.img = require("../assets/img/zjghx.png");
        element.closeBox = true;
      }); */
      /* this.form.zjzpZm = "";
      this.form.zjzpFm = ""; */
    },
    submitForm(formName, formName2) {
      // this.$emit("nextstep", 2);
      let type = false
      let type2 = false
      this.$refs[formName].validate((valid) => {
        type = valid
      })
      this.$refs[formName2].validate((valid2) => {
        type2 = valid2
      })
      if (this.form.zjlx == '4') {
        this.form.jg = ''
        if (!this.form.zjzpZm) {
          this.$message({
            message: '请上传证件照',
            type: 'warning'
          })
          type = false
        }
      } else {
        this.form.qtzj = ''
        if (!this.form.zjzpZm || !this.form.zjzpFm) {
          this.$message({
            message: '请上传证件照',
            type: 'warning'
          })
          type = false
        }
      }
      if (type && type2) {
        this.loading = true
        // 进行下一步
        zhuce(this.form, this.$store.state.RWLCType).then((e) => {
          this.loading = false
          this.$emit('nextstep', 2)
        }).catch((e) => {
          this.loading = false
        })
      } else {
        return false
      }
    },
    jgChange(value) {
      this.jgnum = value.join(',')
      this.form.jg = this.jgnum
    },
    // 上一步
    upstep() {
      // 进行上一步
      this.$emit('nextstep', 0)
    },
    // 上传之前
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp']
      const isLt2M = file.size / 1024 < 500
      const typeTrue = fileType.includes(file.type)
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 500kb!')
      }
      if (!typeTrue) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      return typeTrue && isLt2M
    },
    // 上传时
    onProgress(event, file, fileList) {
      if (this.cardType == '证件人像面') {
        this.cardImg[0].loading = true
      }
      if (this.cardType == '证件国徽面') {
        this.cardImg[1].loading = true
      }
      if (this.cardType == '其他证件') {
        this.cardImg[2].loading = true
      }
    },
    // 上传时
    onProgress1(event, file, fileList) {
      this.cardImg[1].loading = true
    },
    onError() {
      this.$message.error('证件上传失败!')
    },
    // 上传成功后
    onSuccess(response, file, fileList) {
      const data = response.data
      this.loading = false
      if (data.oneData) {
        // OCR识别
        /* for (let key in data.oneData) {
          if (data.oneData[key] != null) {
            this.form[key] = data.oneData[key];
          }
        }
        this.$message.success("证件上传成功!"); */
      } else {
        // this.$message.warning("证件上传成功,但无法识别!请手动填写!");
      }
      if (this.cardType == '证件人像面') {
        this.cardImg[0].img = this.returnShowPic + data.url
        this.cardImg[0].closeBox = true
        this.cardImg[0].loading = false
        this.form.zjzpZm = data.url
      }
      if (this.cardType == '证件国徽面') {
        this.cardImg[1].img = this.returnShowPic + data.url
        this.cardImg[1].closeBox = true
        this.cardImg[1].loading = false
        this.form.zjzpFm = data.url
      }
      if (this.cardType == '其他证件') {
        this.cardImg[2].img = this.returnShowPic + data.url
        this.form.zjzpZm = data.url
        this.cardImg[2].closeBox = true
        this.cardImg[2].loading = false
        // this.form.zjzpFm = data.url;
      }
    },
    onSuccess1(response, file, fileList) {
      const data = response.data
      this.loading = false
      if (data.oneData) {
        // OCR识别
        /* for (let key in data.oneData) {
          if (data.oneData[key] != null) {
            this.form[key] = data.oneData[key];
          }
        }
        this.$message.success("证件上传成功!"); */
      } else {
        // this.$message.warning("证件上传成功,但无法识别!请手动填写!");
      }
      this.cardImg[1].img = this.returnShowPic + data.url
      this.cardImg[1].closeBox = true
      this.cardImg[1].loading = false
      this.form.zjzpFm = data.url
    },
    handleRemove(file, fileList) { },
    handlePreview(file) { },
    handleExceed(files, fileList) { },
    beforeRemove(file, fileList) { }
  }
}
</script>

<style scoped lang='less'>
.step1 {
  .el-col-2 {
    width: 8.33333%;
    text-align: center;
  }
  .deleteUpload {
    width: 25px;
    height: 25px;
    position: absolute;
    right: 0;
    top: 15px;
    cursor: pointer;
    color: white;
  }
  background: #ffffff;
  margin: auto;
  overflow-y: auto;
  // width: 1200px;
  /deep/.el-upload-list {
    margin: 0;
    padding: 0;
    list-style: none;
    position: absolute;
    right: 0;
    top: -10px;
    display: none;
  }
  .disabled .el-upload--picture-card {
    display: none;
  }

  /deep/.el-upload--picture-card {
    border: none;
    box-sizing: border-box;
    width: 227px;
    height: 140px;
    vertical-align: top;
  }
  .card_img {
    margin: auto;
    width: 600px;
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    .card_img_item {
      display: flex;
      flex-direction: column;
      cursor: pointer;

      span {
        margin: 10px auto 0;
        color: #636363;
        font-size: 14px;
      }
    }
  }
  .qita_img {
    margin: auto;
    width: 227px;
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    .qita_img_item {
      display: flex;
      flex-direction: column;
      cursor: pointer;

      span {
        margin: 10px auto 0;
        color: #636363;
        font-size: 14px;
      }
    }
  }
  ._buttonList {
    margin: 80px auto 80px;
    width: 100%;
    display: flex;
    justify-content: center;
    button {
      width: 148px;
      height: 60px;
    }
    button:nth-child(2) {
      margin-left: 190px;
    }
  }

  .el-form {
    display: flex;
    flex-wrap: wrap;
    margin: auto;
    justify-content: space-between;
  }
  /deep/.el-upload-list__item-name {
    color: #606266;
    display: block;
    margin-right: 40px;
    overflow: hidden;
    padding-left: 4px;
    text-overflow: ellipsis;
    transition: color 0.3s;
    white-space: nowrap;
    display: none !important;
  }
  /deep/.el-upload-list {
    margin: 0;
    padding: 0;
    list-style: none;
    position: absolute;
    right: 0;
    top: -10px;
  }
}
._body {
  width: 1200px;
  margin: auto;
}

/deep/.el-radio__inner {
  border-radius: 0;
  border: none;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: none;
  background: url("../assets/img/radiobox_down.png");
  background-size: 100% 100%;
}
/deep/.el-radio__input .el-radio__inner {
  border-color: none;
  background: url("../assets/img/radiobox.png");
  background-size: 100% 100%;
}
/deep/.el-radio__input.is-checked .el-radio__inner::after {
  content: "";
  background: none;
}
/deep/.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 340px;
}
p {
  color: #333333;
  font-size: 16px;
  font-weight: 600;
}
/deep/.CardXX {
  .el-form-item__content {
    width: 340px;
    .el-select {
      width: 340px;
    }
  }
  .el-date-editor .el-range-separator {
    padding: 0 5px;
    line-height: 32px;
    width: 10%;
    color: #303133;
  }
}
/deep/.QtXX {
  .el-form {
    .el-form-item:nth-child(1),
    .el-form-item:nth-child(2) {
      .el-form-item__content {
        width: 340px;
      }
    }
    .el-form-item:nth-child(3) {
      width: 100%;

      .el-form-item__content {
        // width: 856px;
      }
    }
  }
}
</style>
